import { format } from "date-fns";

export function getTodayDateString() {
  return format(new Date(), "yyyy-MM-dd");
}

export function getCurrentTimeString() {
  return format(new Date(), "HH:mm");
}

export function timeToMinutes(timeStr) {
  if (!timeStr) return null;
  const [h, m] = String(timeStr).split(":").map(Number);
  if (!Number.isFinite(h) || !Number.isFinite(m)) return null;
  return h * 60 + m;
}

export function mapApiDetailsToFormErrors(details) {
  if (!details || typeof details !== "object") return {};
  return Object.fromEntries(
    Object.entries(details).map(([k, v]) => [k, String(v ?? "")]),
  );
}

export function safeErrorText(err, fallback = "Something went wrong. Please try again.") {
  const m = err?.message;
  return typeof m === "string" && m.trim() ? m : fallback;
}

const REGISTERED_BY_ROLE_LABELS = {
  office: "Office",
  receptionist: "Reception",
  recep: "Reception",
  reception: "Reception",
  admin: "Admin",
};

/** Role / department label from API (`role_name` or `role_slug`). */
export function formatStaffDepartmentLabel({
  department_name,
  role_name,
  role_slug,
} = {}) {
  const fromName = String(department_name ?? role_name ?? "").trim();
  if (fromName) return fromName;
  const slug = String(role_slug ?? "")
    .trim()
    .toLowerCase();
  return REGISTERED_BY_ROLE_LABELS[slug] || (slug ? slug : "");
}

/** Staff picker / view — name with Office, Reception, etc. */
export function formatPersonWithDepartment(name, meta = {}) {
  const n = String(name ?? "").trim();
  const dept = formatStaffDepartmentLabel(meta);
  if (!n && !dept) return "—";
  if (!dept) return n;
  if (!n) return dept;
  return `${n} (${dept})`;
}

/** Admin directory — staff name plus role that registered the visitor. */
export function formatRegisteredByDisplay(row) {
  const name = String(row?.created_by_name ?? "").trim();
  const slug = String(row?.created_by_role_slug ?? "")
    .trim()
    .toLowerCase();
  const roleLabel =
    formatStaffDepartmentLabel({ role_slug: slug }) || (slug ? slug : "");
  if (!name && !roleLabel) return "—";
  if (!roleLabel) return name;
  if (!name) return roleLabel;
  return `${name} (${roleLabel})`;
}

export async function ensureCsrfToken(getCsrfToken) {
  let token =
    typeof localStorage !== "undefined"
      ? localStorage.getItem("csrf_token") || localStorage.getItem("csrf-token")
      : null;
  if (!token) {
    token = await getCsrfToken();
    if (token && typeof localStorage !== "undefined") {
      localStorage.setItem("csrf_token", token);
      localStorage.setItem("csrf-token", token);
    }
  }
  return token;
}
